import { RouteConfig } from 'react-router-config';

export interface Route {
  forAuth?: boolean;
  component: React.ComponentType<any>;
  key?: React.Key;
  location?: Location;
  exact?: boolean;
  strict?: boolean;
  path?: string | string[];
  loader?: React.ReactElement;
  routes?: RouteConfig[];
  [propName: string]: any;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement> & {
    width?: string | number | undefined;
    height?: string | number | undefined;
    fill?: string | undefined;
    stroke?: string | undefined;
  }>;
  resources?: Route[];
  level?: string | number;
}

export enum Config {
  HOME = '/',
  SHIELD = '/shield',
  PEOPLE = '/people',
  PARITY = '/parity',
  SCIENCE = '/science',
  WORK = '/work',
}